import {Component, Directive, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatIconModule} from "@angular/material/icon";
import {MatCardModule} from "@angular/material/card";
import {FlexModule} from "@angular/flex-layout";

@Directive({
  standalone: true,
  selector: '[appCardContent]'
})
export class AppCardContentDirective {
}

@Directive({
  standalone: true,
  selector: '[appCardActions]'
})
export class AppCardActionsDirective {
}

@Component({
  selector: 'app-card',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatIconModule, FlexModule],
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class AppCardComponent {

  @Input() title!: string;
  @Input() subtitle!: string;
  @Input() iconName!: string;
}
